import React, { useEffect } from "react";
import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import { Row, Col } from "react-bootstrap";
import SearchControl from "../../../components/LeftNavigation/GlobalSearch/SearchControl";
import styles from "./WebServiceMapping.module.css";
import datajson from "../data.json";
import Tree from "../ReusableComp/TreeCustomDataObjects";
import TreeCustom from "../ReusableComp/TreeCustom";

const WebServiceMapping = (props) => {
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const anchor = "right";
  const [stateOpen, setState] = React.useState(false);
  const [filter, setFilter] = React.useState("");
  const [stateForCustomServiceJson, setStateForCustomServiceJson] =
    React.useState();
  const [parentMapping, setparentMapping] = React.useState(false);
  const [childMapping, setchildMapping] = React.useState(false);
  const [parentChildCustom, setParentChildCustom] = React.useState("");
  const [customServiceIds, setcustomServiceIds] = React.useState(new Set());
  const [showMapButtonState, setShowMapButtonState] = React.useState("");

  function cancelHandler() {
    props.setStateMapping(false);
  }

  useEffect(() => {
    setState(props.stateOpen);
  }, [props.stateOpen]);

  const { t } = useTranslation(["styles", "translation"]);

  const useStyles = makeStyles({
    root: {
      "& .MuiDrawer-root": {},
      "& .MuiBackdrop-root": {
        opacity: "1 !important",
      },
      "& .MuiDrawer-paperAnchorRight": {
        width: 741,
        right: t("styles:leftVal"),
        left: t("styles:rightVal"),
        overflowY: "unset",
      },
    },
    list: {
      width: 250,
    },
    fullList: {
      width: "auto",
    },
    headingMapping: {
      color: "#000000",
      marginLeft: "15px",
      marginTop: "15px",
    },
    headingMappingContent: {
      fontWeight: "bold",
    },
    columnFirst: {
      width: "321px",
      border: "1px solid #F0F0F0",
      opacity: 1,
      height: "100%",
      paddingLeft: "0px",
      paddingRight: "0px",
    },
    columnSecond: {
      width: "421px",
      border: "1px solid #F0F0F0",
      opacity: 1,
      height: "100%",
      paddingLeft: "0px",
      paddingRight: "0px",
    },
    allColumns: {
      width: "742px",
      height: "100%",
      marginTop: "10px",
      margin: "0px",
    },
    columnUpperHeading: {
      height: "32px",
      width: "321px",
      backgroundColor: "#F5F5F5",
      border: "1px solid #F0F0F0",
      opacity: "1",
      paddingLeft: "8px",
      paddingTop: "6px",
    },
    columnUpperHeadingSecond: {
      height: "32px",
      width: "421px",
      backgroundColor: "#F5F5F5",
      border: "1px solid #F0F0F0",
      opacity: "1",
      paddingLeft: "8px",
      paddingTop: "6px",
    },
    contentHeading: {
      font: "normal normal 600 12px/13px Open Sans",
      color: "#000000",
    },
  });

  function toggleDrawer() {
    props.setStateMapping(false);
  }

  const xmlCustom = {
    "Document Classification": {
      "Input Parameters": {
        "Document Type": "",
        "Document Id": "",
        "Document Page Number": "",
        "Document Format": "",
        "Document Version": "",
        "Document Desc": "",
        MessageId: "",
      },
    },
  };

  var dataObjectsFromApiJson = {};
  dataObjectsFromApiJson = { children: [] };
  var dataObjectsFromApi = {
    "Document Classification": {
      EE_EAI_HEADER: {
        MsgVersion: "",
        Extra2: "",
        Extra1: "",
        ReturnDesc: "",
        MessageId: "",
      },
      CustomerExposureResponse: {
        ReferenceNumber: "",
        ReportUrl: "",
        RequestType: "",
      },
      ExposureResponse2: {
        RequestType2: "",
      },
    },
  };

  dataObjectsFromApiJson.children = dataObjectsFromApi;
  const [searchWord, setsearchWord] = React.useState("");
  const [searching, setSearching] = React.useState(false);
  function searchThisWord() {
    setSearching(!searching);
  }

  function inputValue(event) {
    setsearchWord(event.target.value);
  }

  const [selectedMappedValue, setSelectedMappedValue] = React.useState("");
  const classes = useStyles();

  return (
    <Drawer
      className={classes.root}
      anchor={anchor}
      open={stateOpen}
      style={{ direction: translationStyles1 ? "rtl" : "ltr" }}
      onClose={() => toggleDrawer()}
    >
      <div className={styles.headingMapping}>
        <span className={styles.headingMappingContent}>
          {t("translation:Input Parameter Mapping")}
        </span>
      </div>
      <Row className={styles.allColumns}>
        <>
          <Col className={styles.columnFirst}>
            <div className={styles.columnUpperHeading}>
              <span className={styles.contentHeading}>
                Select the Controls you want to map
              </span>
            </div>

            <SearchControl
              width={"278px"}
              collapsed={false}
              collapsedWidth={"0px"}
            />

            <Tree
              selectedMappedValue={selectedMappedValue}
              setSelectedMappedValue={setSelectedMappedValue}
              data={datajson}
              setParentChildCustom={setParentChildCustom}
              customServiceIds={customServiceIds}
              setcustomServiceIds={setcustomServiceIds}
            />
          </Col>
        </>

        <div className={styles.columnSecond}>
          <div className={styles.columnUpperHeadingSecond}>
            <span className={styles.contentHeading}>
              {" "}
              Select the parameters you want to map
            </span>
          </div>

          <SearchControl
            width={"378px"}
            collapsed={false}
            collapsedWidth={"0px"}
            on_click_input={(event) => inputValue(event)}
            on_click={() => searchThisWord()}
          />

          <TreeCustom
            containerId={props.containerId}
            key={Math.random() * 10}
            data={xmlCustom}
            samplejson={xmlCustom}
            selectedMappedValue={selectedMappedValue}
            setSelectedMappedValue={setSelectedMappedValue}
            parentChildCustom={parentChildCustom}
            setParentChildCustom={setParentChildCustom}
            saveInJson={props.saveInJson}
            stateForCustomServiceJson={stateForCustomServiceJson}
            setStateForCustomServiceJson={setStateForCustomServiceJson}
            isfirst={true}
            filter={filter}
            ischeckbox={true}
            parentMapping={parentMapping}
            childMapping={childMapping}
            setparentMapping={setparentMapping}
            setchildMapping={setchildMapping}
            searching={searching}
            searchWord={searchWord}
            showMapButtonState={showMapButtonState}
            setShowMapButtonState={setShowMapButtonState}
            customServiceIds={customServiceIds}
            setcustomServiceIds={setcustomServiceIds}
          />
        </div>
      </Row>

      <footer
        style={{
          width: "100%",
          height: "50px",
          color: "gray",
          position: "fixed",
          bottom: 0,
          boxShadow: "0px 1px 10px grey",
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            paddingTop: "11px",
            position: "inherit",
            right: "15px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={`formBuilder-MuiButton-outlined`}
            variant="outlined"
            style={{ width: "54px", height: "28px", fontSize: "12px" }}
            onClick={() => cancelHandler()}
          >
            {t("translation:Cancel")}
          </Button>
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={`formBuilder-MuiButton-outlined`}
            variant="contained"
            style={{
              backgroundColor: "#0072c6",
              color: "white",
              width: "63px !important",
              height: "28px",
              fontSize: "12px",
              marginLeft: "12px",
            }}
            onClick={() => cancelHandler()}
          >
            Save & Exit
          </Button>
        </div>
      </footer>
    </Drawer>
  );
};

export default WebServiceMapping;
